export enum CreateNewEntityStep {
  CREATE_FORM = 0,
  REVIEW_ENTITY = 1,
  RESULTS = 2
}

export const createNewEntityStepKey = (step: CreateNewEntityStep): string => {
  switch (step) {
    case CreateNewEntityStep.CREATE_FORM:
      return "create-form";
    case CreateNewEntityStep.REVIEW_ENTITY:
      return "review-entity";
    case CreateNewEntityStep.RESULTS:
      return "results";
  }
};
